import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faCalendar, faDollarSign, faHashtag } from '@fortawesome/pro-regular-svg-icons';
import getTranslation from '../../../../strings/i18n';
import Inset from 'syf-component-library/ui/spacing/Inset';
import formatDisplayDate from 'syf-js-utilities/formats/formatDisplayDate';
import { Stack } from 'syf-component-library/ui/spacing';
import { validateAmount } from '../../../../helpers/utils/amount-utils';
import useDeviceWidth from '../../../../hooks/use-device-width';
import { StyledTitle } from '../../../../styles/text';
import InfoHeader from '../../../common/info-header';
import TransactionDetail from '../../../common/transaction-detail';
var CancelPaymentConfirm = function (_a) {
    var _b;
    var currentTransaction = _a.currentTransaction;
    var t = getTranslation().t;
    var isMobile = useDeviceWidth();
    var type = currentTransaction.type, status = currentTransaction.status;
    var paymentID = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.identifiers.find(function (identifier) { return identifier.idType === 'PAYMENT_ID'; });
    var displayedTransactionAmount = validateAmount(currentTransaction.amount);
    // TO DO refactor this array and remove heading value and implement the label/value
    var extraInfoArray = [
        {
            detail: displayedTransactionAmount,
            heading: t('activityDetails.amountLabel'),
            icon: faDollarSign,
            title: 'amountLabel'
        },
        {
            detail: formatDisplayDate(new Date((_b = currentTransaction.paymentInfo) === null || _b === void 0 ? void 0 : _b.scheduledDate)),
            heading: t('activityDetails.cancelPayment.scheduledForLabel'),
            icon: faCalendar,
            title: 'scheduled for'
        },
        {
            detail: paymentID === null || paymentID === void 0 ? void 0 : paymentID.id,
            heading: t('activityDetails.confirmationNumberLabel'),
            icon: faHashtag,
            title: 'activityDetails.confirmationNumberLabel'
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(InfoHeader, { description: "PAYMENT", iconType: type, status: status }), _jsxs(Inset, { top: "large", vertical: isMobile ? 'base' : 'large', children: [_jsx(StyledTitle, { align: isMobile ? 'center' : undefined, size: "medium", children: t('activityDetails.cancelPayment.canceledConfirmHeader') }), _jsx(Stack, { size: "large" }), _jsx("dl", { children: extraInfoArray.map(function (label) { return (_jsx(TransactionDetail, { detail: label.detail, heading: label.heading, icon: label.icon, title: label.title, currentFlow: "cancelPayment" }, label.title)); }) })] })] }));
};
export default CancelPaymentConfirm;
//# sourceMappingURL=index.js.map